import type { GlobalConfig } from '@repo/go-ui';
import { Modal, ConfigProvider } from '@repo/go-ui';
import { render as reactRender, unmount as reactUnmount } from 'rc-util/lib/React/render';
import type { ComponentProps, CSSProperties } from 'react';

type ModalProps = ComponentProps<typeof Modal>;
interface ActionsBoxConfig {
  modalBody: (close: (value?: string) => void) => React.ReactNode;
  modalProps?: Partial<ModalProps>;
  configProvider: GlobalConfig;
}

interface ActionsBoxProps {
  modalProps?: Partial<ModalProps>;
  open: boolean;
  close: (value?: string) => void;
  afterClose?: () => void;
  children?: React.ReactNode;
}

export default function modalBox(config: ActionsBoxConfig): Promise<string | undefined> {
  return new Promise((resolve, reject) => {
    const div = document.createElement('div');
    document.body.appendChild(div);

    let currentConfig: ActionsBoxProps = {
      ...config,
      children: config.modalBody(close),
      close,
      open: true,
    };

    const destroy = (value?: string) => {
      reactUnmount(div);

      if (div.parentNode) {
        div.parentNode.removeChild(div);
      }
      if (value !== undefined) {
        resolve(value);
      } else {
        reject(value);
      }
    };

    function close(value?: string) {
      currentConfig = {
        ...currentConfig,
        open: false,
      };
      destroy(value);
      render(currentConfig);
    }

    function render(props: ActionsBoxProps) {
      const style = {
        padding: 16,
        zIndex: 1010,
        ...props.modalProps?.style,
      } as CSSProperties;
      reactRender(
        <ConfigProvider config={config.configProvider}>
          <Modal title={null} onClickOutside={null} closeIcon={false} {...props.modalProps} {...props} style={style} />
        </ConfigProvider>,
        div,
      );
    }

    render(currentConfig);
  });
}
